import React from 'react';
import { Outlet } from 'react-router';

import BotLoginProvider from 'src/providers/BotLoginProvider';
import BotSocketProvider from 'src/providers/BotSocketProvider';
import SocketProvider from 'src/providers/SocketProvider';
import AIAssistantBar from 'src/components/AIAssistantBar';

import Footer from './Footer';
import Header from './Header';

function MainLayout() {
  return (
    <div className="flex flex-col min-h-screen bg-[#101010] text-gray-200">
      {/* ===== Fixed Header ===== */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-[#0c0c0c] border-b border-[#1c1c1c] shadow-sm">
        {/* Apply responsive padding to the header */}
        <div className="px-4 md:px-6">
          <Header />
        </div>
      </header>

      {/* ===== Scrollable Content ===== */}
      <div
        // Adjust top padding to account for a potentially smaller mobile header
        className="flex flex-1 flex-col pt-[56px] md:pt-[64px] overflow-hidden"
        style={{
          scrollbarWidth: 'none', // Firefox
        }}
      >
        <div
          className="flex flex-1 w-full overflow-y-auto overflow-x-hidden"
          style={{
            scrollbarWidth: 'none', // Firefox
          }}
        >
          {/* Invisible but usable scrollbars (WebKit) */}
          <style>{`
            ::-webkit-scrollbar {
              width: 0px;
              height: 0px;
            }
            ::-webkit-scrollbar-thumb {
              background: transparent;
            }
          `}</style>

          <BotLoginProvider>
            <BotSocketProvider>
              <SocketProvider>
                <Outlet />
              </SocketProvider>
            </BotSocketProvider>
          </BotLoginProvider>
        </div>
      </div>

      {/* ===== Footer ===== */}
      <footer className="flex-none border-t border-[#1c1c1c] bg-[#0c0c0c]">
        <Footer />
      </footer>

      {/* ===== Floating AI Assistant ===== */}
      <AIAssistantBar />
    </div>
  );
}

export default MainLayout;